import {_request, _requestForm} from "./api";

export const add = (data) => {
    let params = data
    return new Promise((resolve, reject) => {
        return _request({
            target: 'membership', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (data,membership_guid) => {
    let params = data
    return new Promise((resolve, reject) => {
        return _request({
            target: `membership/${membership_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (documents_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `membership/${documents_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (documents_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `membership/${documents_guid}`, method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};


export const list = (data) => {
    let params = data;
    console.log('params',params)
    return new Promise((resolve, reject) => {
        return _request({
            target: 'membership', method: 'GET', params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listPlayers = (data) => {
    let params = data;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'membership/players', method: 'GET', params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const processMembership = (documents_guid, data) => {
    let params = data;
    return new Promise((resolve, reject) => {
        return _request({
            target: `membership/process-document/${documents_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

